module.exports = __webpack_public_path__ + "img/sad.3235af6c.svg";